import { render, staticRenderFns } from "./ModalMessageTriggers.vue?vue&type=template&id=b27f8ee0&scoped=true"
import script from "./ModalMessageTriggers.vue?vue&type=script&lang=js"
export * from "./ModalMessageTriggers.vue?vue&type=script&lang=js"
import style0 from "./ModalMessageTriggers.vue?vue&type=style&index=0&id=b27f8ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27f8ee0",
  null
  
)

export default component.exports